import { Common } from './common';
import { RpaJob } from './models/rpaJob';
import {
  CreateValues,
  DisplayableWorkflow,
  EncounterWorkflow,
  FindAllOptions,
  Kind,
  Status,
  ViewOptions,
  ViewWorkflow,
  WorkflowV2,
} from './models/workflow';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async findAll<
    T extends EncounterWorkflow | DisplayableWorkflow = DisplayableWorkflow,
  >(options: {
    encounterId?: string;
    ehrInformationId?: string;
    patientOrderId?: string;
    kind?: Kind;
    status?: Status;
    isCurrent?: boolean;
  }): Promise<T[]> {
    const url = this.common.constructPath('/workflows', options);
    return this.common.getJSON(url);
  }

  async findAllCurrent(
    options: FindAllOptions,
  ): Promise<DisplayableWorkflow[]> {
    const url = this.common.constructPath('/workflows/current', options);
    const { workflows } = await this.common.getJSON(url);
    return workflows;
  }

  async findAllCurrentCounts(
    options: FindAllOptions,
  ): Promise<{ [kind: string]: Record<string, number> }> {
    const url = this.common.constructPath('/workflows/current/counts', options);
    const { counts } = await this.common.getJSON(url);
    return counts;
  }

  async findAllView(options: ViewOptions = {}): Promise<ViewWorkflow[]> {
    const url = this.common.constructPath('/workflows/view', options);
    return this.common.getJSON(url);
  }

  async findAllViewKinds(): Promise<Kind[]> {
    const url = this.common.constructPath('/workflows/view/kinds');
    return this.common.getJSON(url);
  }

  async findAllRpaJobsById(id: string): Promise<RpaJob[]> {
    const url = this.common.constructPath(`/workflows/${id}/rpa-jobs`);
    return this.common.getJSON(url);
  }

  async create(args: CreateValues): Promise<WorkflowV2> {
    const url = this.common.constructPath('/workflows');
    return this.common.postJSON(url, args);
  }

  async retry(args: {
    kind: Kind;
    ehrInformationId?: string;
    encounterId?: string;
    patientOrderId?: string;
  }): Promise<{ success: boolean }> {
    const url = this.common.constructPath('/workflows/retry');
    return this.common.postJSON(url, args);
  }
}
